module.exports = __webpack_public_path__ + "/e26648bb750595e0939694aa649f4141.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/customer-cancel-offer/assets/kite.svg
 ** module id = 1040
 ** module chunks = 0
 **/